import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hybridCashPaymentEnabled',
  initialState: false,
  reducers: {
    setHybridCashPaymentEnabled(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setHybridCashPaymentEnabled } = slice.actions;

export default slice.reducer;
